import { useTranslation } from 'react-i18next';
import { IoArrowBackSharp } from 'react-icons/io5';

import { TextButton } from '../../../TextButton';

export function BackToSavedCardButton({ onClick }: { onClick: () => void }) {
  const { t } = useTranslation(undefined, { keyPrefix: 'checkout' });
  return <TextButton onClick={onClick} text={t('backToSavedCards')} icon={<IoArrowBackSharp />} />;
}
